import React from 'react';
import styles from './SocialContainer.scss';
import language from "@lang/language";

const SocialContainer = ({data}) => {

	if (!data) {
		return null;
	}

	return (
	  <div className={styles.socialContainer}>
		  <div className={styles.text}>{data.title}</div>

		  {data.content && data.content.map((item, key) => {
			  return (
				<div className={styles.holder} key={key}>
					<div className={styles.icon}>
						<img
						  src={item.icon}
						  alt={item.iconAlt}
						  title={item.iconAlt + language.shBGTitle}
						  width={24}
						  height={24}
						/>
					</div>
					<div
					  className={styles.text}
					  dangerouslySetInnerHTML={{__html: item.link}}>
					</div>
				</div>
			  );
		  })}
	  </div>
	);
}

export default SocialContainer;
